import React, { FC, memo, useMemo }     from 'react';
import { Formik }                       from 'formik';
import * as Yup                         from 'yup';
import { IInvoicesEmailsPayload }       from '@typings/accountManagement';
import { getValuesFromCheckboxOptions } from '@utils/commonFunctions';
import { bulkValidation }               from '@modules/invoiceManagement/utils/validation';
import { ModalDialog }                  from '@components/index';
import { ICheckboxOption }              from '@components/Checkbox/CheckboxFieldGroup';
import { SendInvoiceForm }              from './SendInvoiceForm';

const sendInvoiceValidationSchema = Yup.object().shape({
  invoicesEmails : bulkValidation('invoicesEmailsCheckboxes'),
  email          : Yup.string()
    .test('is-valid-emails', 'Some emails are not valid', (value: string) => {
      const emailArray = value.split(' ');
      const emailSchema = Yup.string().email().required();
      const emailArraySchema = Yup.array().of(emailSchema);

      try {
        emailArraySchema.validateSync(emailArray);
        return true;
      } catch (err) {
        return false;
      }
    }),
});

interface IProps {
  open                 : boolean;
  invoicesEmailOptions : ICheckboxOption[];
  isLoading            : boolean;
  onCancel             : () => void;
  onSubmit             : (data: IInvoicesEmailsPayload) => Promise<void>;
}

const SendInvoice: FC<IProps> = ({
  open,
  invoicesEmailOptions,
  isLoading,
  onCancel,
  onSubmit,
}) => {
  const initialValues = useMemo(
    () => ({
      email                 : '',
      isWithAdditionalEmail : false,
      invoicesEmails        : getValuesFromCheckboxOptions(invoicesEmailOptions),
    }),
    [invoicesEmailOptions],
  );

  return (
    <ModalDialog
      open     = {open}
      title    = "Select the users that should receive this invoice."
      width    = "xs"
      padding  = "0 30px 15px"
      actions  = {null}
      onClose  = {onCancel}
      fontSize = "18px"
      content  = {(
        <Formik
          initialValues    = {initialValues}
          validationSchema = {sendInvoiceValidationSchema}
          onSubmit         = {onSubmit as () => Promise<void>}
        >
          <SendInvoiceForm
            invoicesEmailOptions = {invoicesEmailOptions}
            isLoading            = {isLoading}
            onCancel             = {onCancel}
            onSubmit             = {onSubmit}
          />
        </Formik>
      )}
    />
  );
};

export const SendInvoiceModal = memo(SendInvoice);
